import axios, { AxiosError } from "axios";
import { useEffect, useState } from "react";
import { useAuth } from "../hooks/auth";
import { api } from "./api";

const AxiosInterceptor = ({ children }: any) => {
  const [isSet, setIsSet] = useState(false);
  const { signOut } = useAuth();

  useEffect(() => {
    const resInterceptor = (response: any) => {
      return response;
    };

    const errInterceptor = (error: AxiosError) => {
      if (
        //@ts-ignore
        error.response.data.error === "token invalid" ||
        //@ts-ignore
        error.response?.data.error === "token not provided"
      ) {
        signOut();
      }

      return Promise.reject(error);
    };

    const interceptor = api.interceptors.response.use(
      resInterceptor,
      errInterceptor
    );

    setIsSet(true);

    return () => api.interceptors.response.eject(interceptor);
  }, []);

  return isSet && children;
};

export { AxiosInterceptor };
